import ApiResponse from "sr/models/ApiResponse";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { post } from "sr/utils/axios";

export const autofillCleaner = async (postData: any) => {
  try {
    return await post<ApiResponse<[]> | any>("/cleaner/autofill", postData);
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};
